import { action, observable } from 'mobx';

import { ToastType, toastTypes } from '@/constants/toasts';
import { Toast } from '@/types/models/toasts';

export default class ToastManagerStore {
  @observable public accessor toasts: Toast[] = [];
  private nextId: number = 1;

  @action.bound add(
    message: string,
    type: ToastType,
    icon?: string,
    duration: number = 3000,
  ) {
    const existingToast = this.toasts.find(
      (toast) => toast.message === message && toast.icon === icon,
    );
    if (existingToast) {
      return;
    }

    const id = this.nextId++;
    this.toasts.push({ id, message, icon, duration, type });

    setTimeout(() => {
      this.removeToast(id);
    }, duration);
  }

  @action.bound success(
    message: string,
    icon?: string,
    duration: number = 3000,
  ) {
    this.add(message, toastTypes.success, icon, duration);
  }

  @action.bound error(message: string, icon?: string, duration: number = 3000) {
    this.add(message, toastTypes.error, icon, duration);
  }

  @action.bound removeToast(id: number) {
    this.toasts = this.toasts.filter((toast) => toast.id !== id);
  }
}
